import React, { useEffect, useRef, useState } from 'react';
import './360Cassette.css';

const Card = ({ items }) => {
    const [isVisible, setIsVisible] = useState(new Array(items.length).fill(false));
    const cardRefs = useRef(items.map(() => React.createRef()));

    useEffect(() => {
      window.scrollTo({ top: 0 });
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // Find the correct index of the observed element.
                const index = cardRefs.current.findIndex(
                  (ref) => ref.current === entry.target
                );

                if (index !== -1) { // Make sure the index is found
                    setIsVisible((prev) => {
                       const newVisibility = [...prev];
                       newVisibility[index] = true;
                       return newVisibility;
                     });
                }
              }
            });
          },
          {
            threshold: 0.8,
          }
        );
  
      cardRefs.current.forEach((ref) => {
        if (ref.current) {
          observer.observe(ref.current);
        }
      });
  
        return () => {
          observer.disconnect();
        };
    }, [items.length]);


    return (
        <div className="flex flex-col space-y-8">
            {items.map((item, index) => (
                <div
                    key={index}
                    ref={cardRefs.current[index]}
                    className={`flex flex-col-reverse md:flex-row translate-y-[50px] ${
                        index % 2 === 0 ? 'md:flex-row-reverse' : ''
                    } items-center md:space-x-8 ${
                        isVisible[index] ? 'opacity-100 animate-slide-up' : 'opacity-0'
                    }`}
                  style={{
                        transition: 'opacity 1s ease-in-out',
                        animationDelay: `${index * 0.2}s`,
                  }}
                >
                    {/* Image */}
                    <div className="flex-shrink-0 w-full md:w-1/2">
                        <img
                            src={item.image}
                            alt={item.title}
                            className="w-full h-full object-cover rounded-lg shadow-md"
                        />
                    </div>

                    {/* Text */}
                    <div className="w-full md:w-1/2 text-center md:text-left">
                        <h2 className="text-2xl font-bold mb-4">{item.title}</h2>
                        <p className="text-gray-600">{item.description}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Card;